
import { defineComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';
import MessageWrap from '@/components/MessageWrap/index.vue';
import ButtonModel from '@/models/ButtonModel';

export default defineComponent({
	name: 'multiple-choice',

	components: {
		MessageWrap
	},

	props: {
		message: {
			type: Object as PropType<Message>,
			required: true
		},

		isShowMessageTail: {
			type: Boolean
		},

		isLastMessage: {
			type: Boolean
		},

		avatar: {
			type: String
		}
	},

	emits: ['send-message', 'init'],

	data() {
		return {
			selected: [] as Array<number>
		};
	},

	mounted() {
		this.$emit('init');
	},

	computed: {
		buttonsAsCheckbox(): Array<ButtonModel> {
			return this.buttons.filter((b) => b.checkbox);
		},

		continueButton(): ButtonModel {
			return this.buttons[this.buttons.length - 1];
		},

		buttons(): Array<ButtonModel> {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			return this.message.buttons!;
		}
	},

	methods: {
		toggleButton(order: number) {
			if (this.isSelected(order)) {
				this.selected = this.selected.filter((o) => o !== order);
			} else {
				this.selected.push(order);
			}
		},

		isSelected(order: number) {
			return this.selected.includes(order);
		},

		send() {
			const text = this.continueButton.command ?? this.continueButton.text;
			const params = {
				...this.continueButton.params,
				checked_answers: this.selected
			};

			const payload = {
				text,
				textBody: this.continueButton.text,
				params,
				type: 'command'
			};

			this.$emit('send-message', payload);
		}
	}
});
